/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SKIP_NAVIGATION_ON_ERROR } from '@eng-dx-gpt/api-client';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IGNORED_STATUSES, SKIP_ERROR_HANDLER } from './context/utility.context';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const skipErrorHandler = req.context.get(SKIP_ERROR_HANDLER);
  if (skipErrorHandler) {
    return next(req);
  }

  const router = inject(Router);

  return next(req).pipe(catchError((event: HttpEvent<unknown>) => handleError(req, event, router)));
};

const handleError: (req: HttpRequest<unknown>, event: HttpEvent<any>, router: Router) => Observable<HttpEvent<any>> = (
  req,
  event,
  router
) => {
  const ignoreStatus = req.context.get(IGNORED_STATUSES);
  const skipNavigation = req.context.get(SKIP_NAVIGATION_ON_ERROR);

  if (event instanceof HttpErrorResponse && ignoreStatus.includes(event.status.toString())) {
    return throwError(() => event);
  }

  if (event instanceof HttpErrorResponse && !skipNavigation) {
    switch (event.status) {
      case 400:
        break;
      case 401:
        router.navigate(['not-authorized']);
        break;
      case 403:
        router.navigate(['forbidden']);
        break;
      case 404:
        router.navigate(['error', 'not-found']);
        break;
      case 500:
        break;
      default:
        router.navigate(['error', 'not-found']);
    }
  }
  return throwError(() => event);
};
